// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"UMYGLQCaJIAe-pJSywiUO","dropdown__content":"_1zxsbNeu2HWbfXnsUIaam1","dropdown--active":"PlGxQhiT-AWvGT0tvNnOl"};